/**
 * @date: 12/9/20
 * @author: Yan Wang <ywang@max.md>
 * @copy: (C) Copyright 2020 MaxMD Corporation, All Rights Reserved.
 *
 */

import React from "react";
import PropTypes from 'prop-types';
// import MaskedInput from "react-text-mask";
import {getDateFromString, getDaysToExpire, printTime} from "./cert-helper";

export const DirectTrustOid = {

}

export const OID_DT_LeveryOfAuthority = "1.3.6.1.4.1.41179.1";
export const OID_DT_PolicyVersion = "1.3.6.1.4.1.41179.0.1";
export const OID_DT_Device = "1.3.6.1.4.1.41179.3.1";
export const OID_DT_Category = "1.3.6.1.4.1.41179.2";
export const OID_DT_CPv20 = "1.3.6.1.4.1.41179.0.2.0";

export const USER_REVOKE_REASONS = [
    'keyCompromise',  'affiliationChanged', 'superseded', 'cessationOfOperation', 'certificateHold',  'privilegeWithdrawn',  'unspecified'
]
export const ADMIN_REVOKE_REASONS = [
    'keyCompromise', 'cACompromise', 'affiliationChanged', 'superseded', 'cessationOfOperation', 'certificateHold', 'removeFromCRL', 'privilegeWithdrawn', 'aACompromise', 'unspecified'
]

export const DT_EMAIL = 'support@directtrust.zohodesk.com';
export const IDME_HELP_URL = 'https://help.id.me/';

export function isDtLoaOid(oid){
    return oid && oid.indexOf(OID_DT_LeveryOfAuthority) === 0;
}

export function isDtPolicyOid(oid){
    return oid && oid.indexOf(OID_DT_PolicyVersion) === 0;
}
export function isDtDeviceOid(oid){
    return oid === OID_DT_Device;
}
export function isDtCategory(oid){
    return oid && oid.indexOf(OID_DT_Category) === 0;
}
export function getOidName(oid){
    if (isDtLoaOid(oid)){
        if (oid === OID_DT_LeveryOfAuthority + ".1"){
            return "DirectTrust LoA1";
        } else if (oid === OID_DT_LeveryOfAuthority + ".2"){
            return "DirectTrust LoA2";
        } else if (oid === OID_DT_LeveryOfAuthority + ".3"){
            return "DirectTrust LoA3";
        } else if (oid === OID_DT_LeveryOfAuthority + ".5"){
            return "DirectTrust IAL2";
        } else if (oid === OID_DT_LeveryOfAuthority + ".5"){
            return "DirectTrust IAL3";
        }
    } else if (isDtPolicyOid(oid)){
        const version = oid.substr(OID_DT_PolicyVersion.length + 1);
        return `Certificate Policy V${version}`;
    } else if (isDtDeviceOid(oid)){
        return `Device Certificate`;
    } else if (isDtCategory(oid)){
        if (oid === OID_DT_Category + ".1"){
            return "Covered Entity";
        } else if (oid === OID_DT_Category + ".2"){
            return "Business Associate";
        } else if (oid === OID_DT_Category + ".3"){
            return "Health Entity";
        } else if (oid === OID_DT_Category + ".5"){
            return "Patient";
        } else if (oid === OID_DT_Category + ".5"){
            return "NonDeclared";
        }
    } else if (oid === OID_DT_CPv20){
        return "DirectTrust CP v2.0"
    }

    return "";

}

export function isMasterAdmin(user){
    return user && user.userType && user.userType.toLowerCase() === "masteradmin";
}
export function isSystem(user){
    return user && user.userType && user.userType.toLowerCase() === "system";
}

export function isAdmin(user){
    return user && user.userType && user.userType.toLowerCase() === "admin";
}

export function isAccountActive(account) {
    if (!account){
        return false;
    }
    if (account.user && isUserActive(account.user)){
        return true;
    }
    return false;
    // return account && isUserActive(account.user);
}
export function isUserActive(user) {
    return user && user.status === "active";
}

export function getOrganizationAddress(org) {
    var street = org.street1;
    if (org.street2){
        street += ", " + org.street2;
    }
    return `${street}, ${org.city}, ${org.state} ${org.zip5}`;
}

export function getKeyName(name){
    var key = "";

    if (name){
        var arr = name.trim().split(" ");
        for (var i=0; i<arr.length; i++){
            const item = arr[i].trim();
            if (item !== ""){
                const ch = item.substr(0, 1).toUpperCase();
                if (ch >= 'A' && ch <= 'Z'){
                    key  = key + ch;
                    if (key.length >= 3){
                        break;
                    }
                }
            }
        }
    }
    return key;
}

export function capitalFirstChar(text){
    if (text && text.length > 0){
        return text.substr(0, 1).toUpperCase() + text.substr(1);
    }
    return  "";
}

export function compareString(s1, s2, caseSensitive){
    if (!s1 || !s2){
        return false;
    }
    if (caseSensitive){
        return s1.trim() === s2.trim();
    } else {
        return s1.trim().toLowerCase() === s2.trim().toLowerCase();
    }
}

export function printOrganizationAddressInOneLine(org){
    var s = `${org.street1}`;
    if (org.street2){
        s += `, ${org.street2}`;
    }
    s += `, ${org.city}, ${org.state} ${org.zip5}, ${org.country}`
    return s;
}
export function printOrganizationAddress(org){
    if (org){
        return <address>
            {org.street1}
            {org.street2 && <><br/> {org.street2} </>}
            <br/> {org.city}
            <br/> {`${org.state} ${org.zip5}`}

            {org.country && <><br/> {org.country} </>}
        </address>
    } else {
        return <></>
    }
}

export function getTokenLinkUrl(account, link){
    if (link){
        if (link.id && link.token && account && account.server && account.server.portalPublicEndpoint){
            return `${account.server.portalPublicEndpoint}/activate/tokenLink/${link.id}?token=${link.token}`;
        } else {
            return link.linkUri;
        }
    }
    return null;
}

/**
 * TextMaskCustom
 */
// export function TextMaskPhoneNumber(props) {
//     const { inputRef, ...other } = props;
//
//     return (
//         <MaskedInput
//             {...other}
//             ref={(ref) => {
//                 inputRef(ref ? ref.inputElement : null);
//             }}
//             mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
//             placeholderChar={'\u2000'}
//             showMask
//         />
//     );
// }
// TextMaskPhoneNumber.propTypes = {
//     inputRef: PropTypes.func.isRequired,
// };
//
//
// export function TextMaskNpi(props) {
//     const { inputRef, ...other } = props;
//     const mask = [];
//     for (var i=0; i<10; i++){
//         mask.push(/\d/);
//     }
//     return (<MaskedInput {...other} ref={(ref) => { inputRef(ref ? ref.inputElement : null); }} mask={mask} placeholderChar={'\u2000'} showMask />);
// }
//
// TextMaskNpi.propTypes = {
//     inputRef: PropTypes.func.isRequired,
// };


export function readyToRenew(daysToExpire){
    return daysToExpire <= 90;
}

export function certificateReadyToRenew(c){
    if (!c){
        return false;
    }
    console.log('certificateReadyToRenew', c);
    if (c.reissueStatus && c.reissueStatus.toLowerCase() === "completed"){
        // already renewed
        return false;
    }
    const expDate = c.validTo ? getDateFromString(c.validTo) : null;
    const daysToExp = getDaysToExpire(expDate);
    return readyToRenew(daysToExp);
}

export function getProfileLabel(profile){
    if (profile){
        const lower = profile.trim().toLowerCase();
        if (lower === "ehealthexchange" || lower === "ehealth exchange"){
            return "eHealth Exchange";
        } else if (lower === "carequality" || lower === "care quality"){
            return "Carequality";
        }
    }
    return "";
}

export function getAdtDescription(triggerEvent){
    if (triggerEvent){
        triggerEvent = triggerEvent.toUpperCase().trim();
        if (triggerEvent === "A01"){ return 'Admit';
        } else if (triggerEvent === 'A02'){ return 'Transfer';
        } else if (triggerEvent === 'A03'){ return 'Discharge';
        } else if (triggerEvent === 'A04'){ return 'Register';
        } else if (triggerEvent === 'A05'){ return 'Pre-Admit';
        } else if (triggerEvent === 'A06'){ return 'Change Outpatient to Inpatient';
        } else if (triggerEvent === 'A07'){ return 'Change Inpatient to Outpatient';
        } else if (triggerEvent === 'A08'){ return 'Update';
        } else if (triggerEvent === 'A09'){ return 'Patient Departing';
        } else if (triggerEvent === 'A10'){ return 'Patient Arriving';
        } else if (triggerEvent === 'A11'){ return 'Cancel Admit';
        } else if (triggerEvent === 'A12'){ return 'Cancel Transfer';
        } else if (triggerEvent === 'A13'){ return 'Cancel Discharge';
        } else if (triggerEvent === 'A14'){ return 'Pending Admit';
        } else if (triggerEvent === 'A15'){ return 'Pending Transfer';
        } else if (triggerEvent === 'A16'){ return 'Pending Discharge';
        } else if (triggerEvent === 'A17'){ return 'Swap Patients';
        } else if (triggerEvent === 'A18'){ return 'Merge Patient Information';
        } else if (triggerEvent === 'A20'){ return 'Bed Status Update';
        } else if (triggerEvent === 'A21'){ return 'Patient Goes on a Leave of Absence';
        } else if (triggerEvent === 'A22'){ return 'Patient Returns from a Leave of Absence';
        } else if (triggerEvent === 'A23'){ return 'Delete a Patient Record';
        } else if (triggerEvent === 'A24'){ return 'Link Patient Information';
        } else if (triggerEvent === 'A25'){ return 'Cancel Pending Discharge';
        } else if (triggerEvent === 'A26'){ return 'Cancel Pending Transfer';
        } else if (triggerEvent === 'A27'){ return 'Cancel Pending Admit';
        } else if (triggerEvent === 'A28'){ return 'Add Person Information';
        } else if (triggerEvent === 'A29'){ return 'Delete Person Information';
        } else if (triggerEvent === 'A30'){ return 'Merge Person Information';
        } else if (triggerEvent === 'A31'){ return 'Update Person Information';
        } else if (triggerEvent === 'A32'){ return 'Cancel Patient Arriving - Tracking';
        } else if (triggerEvent === 'A33'){ return 'Cancel Patient Departing - Tracking';
        } else if (triggerEvent === 'A34'){ return 'Merge Patient information - Patient ID Only';
        } else if (triggerEvent === 'A35'){ return 'Merge Patient Information - Account Number Only';
        } else if (triggerEvent === 'A36'){ return 'Merge Patient Information - Patient ID & Account Number';
        } else if (triggerEvent === 'A37'){ return 'Unlink Patient Information';
        } else if (triggerEvent === 'A38'){ return 'Cancel Pre-Admit';
        } else if (triggerEvent === 'A39'){ return 'Merge Person - Patient ID';
        } else if (triggerEvent === 'A40'){ return 'Merge Patient - Patient Identifier List';
        } else if (triggerEvent === 'A41'){ return 'Merge Account - Patient Account Number';
        } else if (triggerEvent === 'A42'){ return 'Merge Visit - Visit Number';
        } else if (triggerEvent === 'A43'){ return 'Move Patient Information - Patient Identifier List';
        } else if (triggerEvent === 'A44'){ return 'Move Patient Information - Patient Account Number';
        } else if (triggerEvent === 'A45'){ return 'Move Visit Information - Visit Number';
        } else if (triggerEvent === 'A46'){ return 'Change Patient ID';
        } else if (triggerEvent === 'A47'){ return 'Change Patient Identifier List';
        } else if (triggerEvent === 'A48'){ return 'Change Alternate Patient ID';
        } else if (triggerEvent === 'A49'){ return 'Change Patient Account Number';
        } else if (triggerEvent === 'A50'){ return 'Change Visit Number';
        } else if (triggerEvent === 'A51'){ return 'Change Alternate Visit ID';
        } else if (triggerEvent === 'A52'){ return 'Cancel Leave of Absence for a Patient';
        } else if (triggerEvent === 'A53'){ return 'Cancel Patient Returns from a Leave of Absence';
        } else if (triggerEvent === 'A54'){ return 'Change Attending Doctor';
        } else if (triggerEvent === 'A55'){ return 'Cancel Change Attending Doctor';
        } else if (triggerEvent === 'A60'){ return 'Update Adverse Reaction Information';
        } else if (triggerEvent === 'A61') {
            return 'Change Consulting Doctor';
        }

    }
}

export function getUnableToRunBatchMessage(batch){
    return `Another process is running since ${printTime(batch.createdTs)}`;
}

export function validateOrganizationMessagePermission(account){
    if (account && account.organization){
        if (!account.organization.messageModule){
            window.location.href = "/";
        }
    }
}
export function validateOrganizationOutboundNotificationPermission(account){
    if (account && account.organization){
        if (!account.organization.sendNotificationModule){
            window.location.href = "/";
        }
    }
}
export function validateOrganizationInboundNotificationPermission(account){
    if (account && account.organization){
        if (!account.organization.notificationModule){
            window.location.href = "/";
        }
    }
}
export const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
}
